import { useEffect } from "react";

// Schema.org Product JSON-LD + title/description so crawlers (OAI-SearchBot, Google) understand product pages.
export function ProductSchema({ product, price, url }) {
  useEffect(() => {
    if (!product?.name) return undefined;
    const prevTitle = document.title;
    const desc = (product.excerpt || product.blurb || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim().slice(0, 300);
    const data = {
      "@context": "https://schema.org", "@type": "Product", name: product.name, description: desc,
      sku: String(product.post_id || product.id || ""), brand: { "@type": "Brand", name: "OreVital" },
      image: (product.media || []).filter((m) => m.type === "image").map((m) => m.url).concat(product.image_url ? [product.image_url] : []).filter((v, i, a) => a.indexOf(v) === i),
      offers: { "@type": "Offer", url, priceCurrency: "USD", price: Number(price || 0).toFixed(2), itemCondition: "https://schema.org/NewCondition",
        availability: Number(product.inventory || 0) > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
        seller: { "@type": "Organization", name: "OreVital Performance Peptides" } },
    };
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-testid", "product-jsonld");
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    document.title = `${product.name} · OreVital`;
    let meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content") || "";
    if (meta && desc) meta.setAttribute("content", desc);
    return () => {
      el.remove();
      document.title = prevTitle;
      if (meta) meta.setAttribute("content", prevDesc);
    };
  }, [product, price, url]);
  return null;
}
